import {
    PaymentCardIDType,
    useAddDealerCardMutation,
    useDeleteDealerCardMutation,
    useGetDealerCardQuery
} from "../../api/paymentApi";
import Payment from "./Payment";

const DealerPayment = () => {
    const {data, isLoading, refetch} = useGetDealerCardQuery(null)
    const [addCard, resultsAddCard] = useAddDealerCardMutation()
    const [deleteCard] = useDeleteDealerCardMutation()

    const handleAddCard = async ({id}: PaymentCardIDType) => {
        return await addCard({id})
    }

    const handleDeleteCard = async ({id}: PaymentCardIDType) => {
        return await deleteCard({id})
    }

    return (
        <Payment
            addCard={handleAddCard}
            deleteCard={handleDeleteCard}
            isLoadingAddCard={resultsAddCard.isLoading}
            isLoadingCards={isLoading}
            refetchCards={refetch}
            cards={data ? data : []}
        />
    );
};

export default DealerPayment;
